import ErrorImg from '../../../assets/full_page_error.svg?react';
import '../../../errorHandler/ErrorView.less';
import { Button } from '@imprivata-cloud/components';
import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { setupLinkRegenerate } from '../../../api/setupServices';

import { SearchParams } from '../../../api/constants';

export function TokenExpiredErrorView() {
  const [searchParams] = useSearchParams();
  const bearerToken = searchParams.get(SearchParams.BEARER_TOKEN);
  const [isEmailSent, setIsEmailSent] = useState(false);

  const regenerateLinkMutation = useMutation({
    mutationFn: async () => {
      await setupLinkRegenerate(bearerToken);
      setIsEmailSent(true);
    },
  });

  return (
    <div className={'error-view-container'}>
      <ErrorImg />
      <h3>Link expired</h3>
      <Button
        onClick={() => regenerateLinkMutation.mutate()}
        disabled={regenerateLinkMutation.isPending || isEmailSent}
      >
        Send me another Welcome email
      </Button>
      {isEmailSent && <div>Check your inbox in a few minutes for the new Welcome email</div>}
    </div>
  );
}
